import React, { useState } from "react";
import { Card, CardBody } from "react-bootstrap";
import { TabContent, TabPane } from "reactstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import PillNavigation from "../../../components/SubNavBar";
import { NAV_LIST_PRODUCTS } from "../../../dummyData/FoodItemData";
import MenuItemAvailableDays from "./MenuItemAvailableDays";
import ComboItemsAvailableDays from "./ComboMenuAvailableDays";
import CustomizeMenuAvailableDays from "./CustomMenuAvailableDays";

const ProductTable = () => {
  const [active, setActive] = useState(1);

  const toggle = (tab: any) => {
    setActive(tab);
  };

  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card>
        <CardBody>
          <PillNavigation
            navList={NAV_LIST_PRODUCTS}
            active={active}
            toggle={toggle}
          />
          <TabContent className="py-50" activeTab={active}>
            {active === 1 && (
              <div className="subnavbareachpart">
                <TabPane tabId={1}>
                  <MenuItemAvailableDays />
                </TabPane>
              </div>
            )}
            {active === 2 && (
              <div className="subnavbareachpart">
                <TabPane tabId={2}>
                  <ComboItemsAvailableDays />
                </TabPane>
              </div>
            )}
            {active === 3 && (
              <div className="subnavbareachpart">
                <TabPane tabId={3}>
                  <CustomizeMenuAvailableDays />
                </TabPane>
              </div>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default ProductTable;
